import { IProperty } from '../data/entities/property';

import { countries } from 'country-code-lookup';
import { IAddress } from '../view/components/address';
import { IConfiguredHttp } from './http';

export interface ICoordinates {
	lng: number;
	lat: number;
}

export interface IGoogleMapsApi {
	getCoordinatesByProperty(property: IProperty | IAddress): Promise<ICoordinates>;
}

export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY || 'GOOGLE_MAPS_API_KEY_ENV_UNSET_ERROR';

const getCoordinates = (payload: any): ICoordinates => ({
	lng: payload.results && payload.results.length ? payload.results[0].geometry.location.lng : 0,
	lat: payload.results && payload.results.length ? payload.results[0].geometry.location.lat : 0
});

const googleApiFactory = (http: IConfiguredHttp): IGoogleMapsApi => ({
	getCoordinatesByProperty(property) {
		// Stringfy address details from property atributes
		const countryDetails = countries.find((c) => c.iso2 === property.country_code);
		const countryName = (countryDetails ? countryDetails.country : '');
		const address = `${property.address1}+${property.address2}+${property.city}+${property.postcode}+${countryName}`;

		return http.get(`json?address=${address}&key=${GOOGLE_MAPS_API_KEY}`).then((data) => getCoordinates(data));
	}
});

export default googleApiFactory;
